import React, { useState } from "react";
import { styles } from "../../contracts/estimateStyle.tsx";
import TwoColumnLayout from "../../layouts/TwoColumnLayout.tsx";
import PdfPreviewLayout from "../../layouts/PdfPreviewLayout.tsx";
import useEstimateForm from "../../hooks/useEstimateForm.ts";
import { coverFields } from "../../contracts/estimates/types.ts";
import { useEstimateApi } from "../../hooks/useEstimateApi.ts";
import LoadingInContainer from "../../components/LoadingInContainer.js";

import { useFormContext, Controller } from "react-hook-form";
import { Button } from "reactstrap";

interface CoverFormProps {
    onNext: () => void;
    onPreview: () => void;
    coverPdfBlob: Blob | null;
    activeStep: number;
    totalSteps: number;
}

export default function CoverForm({
    onNext,
    onPreview,
    coverPdfBlob,
    activeStep,
    totalSteps
}: CoverFormProps) {
    
    const { control } = useFormContext();
    const { autoGrow } = useEstimateApi()
    const { coverForm, handleChange,
        coverLoading,
        handlePurposeChange } = useEstimateForm();

    return (
        <TwoColumnLayout
        right={
        <div className="p-4 space-y-4">
            <form style={styles.form}>
                <h2 style={styles.heading}>견적서 등록</h2>
                <h3 style={styles.label}>요청 항목</h3>
                    <div style={styles.checkboxGroup}>
                    {[
                        { label: "긴급",       name: "cbEmergency" },
                        { label: "검토요망",     name: "cbReview" },
                        { label: "메모요망",     name: "cbMemo" },
                        { label: "답신요망",     name: "cbReply" },
                        { label: "재사용",         name: "cbReuse" },
                    ].map(({ label, name }) => (
                        <Controller
                            key={name}
                            name={`cover.purpose.${name}` as const}
                            control={control}
                            defaultValue={coverForm.purpose[name]}
                            render={({ field }) => (
                                <label style={styles.checkboxItem}>
                                    <input
                                        type="checkbox"
                                        {...field}
                                        checked={field.value}
                                        onChange={(e) => {
                                            field.onChange(e.target.checked)
                                            handlePurposeChange(e as any)
                                        }}
                                    />
                                    {label}
                                </label>
                            )}
                        />
                    ))}
                </div>
                {coverFields.map(({ label, name, type, required, multiline }) => (
                <div style={styles.fieldGroup} key={name}>
                    <label style={styles.label}>
                    {label}
                    {required && <span style={styles.required}>*</span>}

                    <Controller
                        key={name}
                        name={`cover.${name}` as const}
                        control={control}
                        defaultValue={coverForm[name]}
                        rules={required ? { required: true } : undefined}
                        render={({ field }) =>
                            multiline ? (
                                <textarea
                                    {...field}
                                    rows={5}                           // 기본 5줄
                                    value={coverForm[name]}
                                    style={styles.textarea}
                                    onChange={(e) => {
                                        field.onChange(e);
                                        handleChange(e as any);          // 같은 핸들러 재사용
                                        autoGrow(e.target);              // 높이 자동 조정
                                    }}
                                />
                            )
                            : (
                                <input
                                    {...field}
                                    type={type}
                                    style={styles.input}
                                    onChange={(e) => {
                                        field.onChange(e);
                                        handleChange(e as any);
                                    }}
                                />
                            )
                        }
                    />
                    </label>
                </div>
                ))}
            </form>

            <div 
                className="space-x-2" 
                style={{
                    display: "flex",
                    justifyContent: "flex-end", // ① 오른쪽 끝으로 밀기
                    gap: "0.5rem",              // ② 버튼 간 간격(기존 space-x-2 대체)
                }}
            >
                <Button
                onClick={onPreview}
                style={styles.button}
                >
                미리보기 생성
                </Button>

                {activeStep == 0 && (
                    <Button 
                        onClick={onNext}
                        style={styles.button}
                         >
                        다음
                    </Button>
                )}
            </div>
        </div>
        }
        left={ 
            coverPdfBlob ? <PdfPreviewLayout blob={coverPdfBlob} />
             : (
                <p style={styles.largeText}>
                    미리보기가 없습니다.
                </p>
            )
        }
        />
    );
}
